export const heartBeatPages = [
  "M3_PrivacyPolicy",
  "M3_Offers",
  "M3_Contract",
  "M3_Software",
  "M3_ElectronicDownPaymentStatus",
  "M3_Complete",
  "M3_TermsAndConditions",
  "M3_IdentificationUploader",
  "M3_CX_Wait_ValidationView",
  "M3_ExternalIdUploader",
  "M3_CustomerDeclinedValidation",
  "M3_CustomerContactInfoView",
];
